/** Mobile is below 592px; 592px and above uses Web publishing settings. */
export const MOBILE_PUBLISH_MAX_WIDTH_PX = 591

export const RTC_PUBLISH_FPS_WEB = 30

export const RTC_PUBLISH_FPS_MOBILE = 24

export type ResolveRtcPublishFpsOptions = {
  /** When set, skips viewport detection. */
  mobile?: boolean
  /** Explicit fps override. */
  fps?: number
  /** Upload/file publish — use detail encoding and higher max bitrate. */
  highQuality?: boolean
}

export function isMobilePublishEnvironment(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia(`(max-width: ${MOBILE_PUBLISH_MAX_WIDTH_PX}px)`).matches
}

export function resolveRtcPublishFps(options: ResolveRtcPublishFpsOptions = {}): number {
  if (typeof options.fps === 'number' && Number.isFinite(options.fps) && options.fps > 0) {
    return options.fps
  }
  const mobile = options.mobile ?? isMobilePublishEnvironment()
  return mobile ? RTC_PUBLISH_FPS_MOBILE : RTC_PUBLISH_FPS_WEB
}

export function resolveRtcPublishFrameIntervalS(options?: ResolveRtcPublishFpsOptions): number {
  return 1 / resolveRtcPublishFps(options)
}

/** Web @ 30fps — use {@link resolveRtcPublishFrameIntervalS} when mobile-aware. */
export const RTC_PUBLISH_FRAME_INTERVAL_S = 1 / RTC_PUBLISH_FPS_WEB

export const RTC_PUBLISH_FRAME_INTERVAL_MS = 1000 / RTC_PUBLISH_FPS_WEB

/** Tolerance when comparing media-time deltas (seconds). */
export const MEDIA_TIME_EPSILON_S = 0.001

/** Media time jumped backward beyond this threshold — treat as loop/seek reset. */
export const MEDIA_TIME_LOOP_JUMP_S = 0.05
